import { render, staticRenderFns } from "./MomoHome.vue?vue&type=template&id=2a9d4fb1&"
import script from "./MomoHome.vue?vue&type=script&lang=js&"
export * from "./MomoHome.vue?vue&type=script&lang=js&"
import style0 from "./MomoHome.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports